
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { initializeGA, trackPageView, getDeviceType } from "@/utils/analytics";

export const Analytics = () => {
  const location = useLocation();
  const deviceType = getDeviceType();

  useEffect(() => {
    // Initialize Google Analytics on first load
    initializeGA();
    // Set the device type as a custom dimension on load
    if (ReactGA.isInitialized) {
      ReactGA.set({ dimension1: deviceType });
      console.debug(`Analytics component: GA initialized (${deviceType})`);
    }
  }, [deviceType]);

  useEffect(() => {
    // Track page views when the location changes
    if (ReactGA.isInitialized) {
      trackPageView(location.pathname);
      console.debug("Analytics component: Page view tracked for", location.pathname, `(${deviceType})`);
    }
  }, [location, deviceType]);

  return null;
};
